module.exports = __webpack_public_path__ + "static/dearest_life-2c3b3adaca2bfe14ceb1556db0d8d831.svg";